import { computed as c, createBlock as s, createElementBlock as d, openBlock as o, unref as p, normalizeClass as l, withCtx as u, createElementVNode as g, toDisplayString as r } from "vue";
import { tagColors as w } from "../../constants/colors.js";
/* empty css         */
import e from "../anchor-element/anchor-element.vue.js";
const m = { class: "ds-tag__text" }, y = /* @__PURE__ */ Object.assign({
  name: "DsTag"
}, {
  __name: "tag",
  props: {
    label: { type: String, default: "" },
    color: { type: String, default: "grey", validator: (a) => !a || w.includes(a) },
    link: { type: String, default: "" },
    trackingData: e.props.trackingData,
    openInNewWindow: e.props.openInNewWindow,
    nuxt: e.props.nuxt,
    prefetch: e.props.prefetch,
    ariaLabel: e.props.ariaLabel,
    download: e.props.download
  },
  setup(a) {
    const t = a, n = c(() => t.color ? `ds-tag--${t.color}` : null);
    return (i, f) => a.link ? (o(), s(p(e), {
      key: 0,
      url: a.link,
      "tracking-data": { "component-name": i.$options.name, ...a.trackingData },
      "open-in-new-window": a.openInNewWindow,
      nuxt: a.nuxt,
      prefetch: a.prefetch,
      "aria-label": a.ariaLabel,
      download: a.download,
      class: l(["ds-tag ds-tag--with-link", [n.value]])
    }, {
      default: u(() => [
        g("span", m, r(a.label), 1)
      ]),
      _: 1
    }, 8, ["url", "tracking-data", "open-in-new-window", "nuxt", "prefetch", "aria-label", "download", "class"])) : (o(), d("span", {
      key: 1,
      class: l(["ds-tag", [n.value]])
    }, r(a.label), 3));
  }
});
export {
  y as default
};
